// extracted by mini-css-extract-plugin
export default {"r_l":"a0a187aa00 b6b0e0d2ce","t":"e0ba677c7b"};